import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Table } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { Conditional } from '@resurs/react-utils'
import config from '../../../../../../config'
import { getText } from '../../../../internal/TextLabels'
import InvoiceInfo from './InvoiceInfo'
import styles from './styles.module.scss'
import { TransactionTypes } from '../../../../util/transactionConstants'
import SendDebitConfirmation from './SendDebitConfirmation'
import { PaymentMethods } from '../../../../models/payment-methods'
import { ChannelType } from '../../../../models/channelType'

const PaymentLogEntry = ({ entry, payment, index }) => {
  const translateEntryType = entryType => {
    switch (entryType) {
      case TransactionTypes.CREATE:
        return getText('transactions.transaction.history.create')
      case TransactionTypes.DEBIT:
        return getText('transactions.transaction.history.debit')
      case TransactionTypes.CREDIT:
        return getText('transactions.transaction.history.credit')
      case TransactionTypes.ANNUL:
        return getText('transactions.transaction.history.annul')
      case TransactionTypes.MODIFY_CART:
        return getText('transactions.transaction.history.changes')
      default:
        return entryType
    }
  }

  const headers = extraColumn => (
    <tr>
      <th className={midas.textLeft} style={{ width: '190px' }}>
        {getText('transactions.headers.date')}
      </th>
      <th className={midas.textLeft} style={{ width: '250px' }}>
        {getText('transactions.headers.createdBy')}
      </th>
      <th className={midas.textLeft} style={{ width: '160px' }}>
        {getText('transactions.headers.totalAmount')}
      </th>
      <Conditional
        when={
          entry.channelType === ChannelType.ECOMMERCE ||
          entry.channelType === ChannelType.CHECKOUT_POS ||
          entry.channelType === ChannelType.MERCHANT_API ||
          (entry.channelType === ChannelType.MERCHANT_PORTAL &&
            payment.paymentMethod.type === PaymentMethods.RESURS_INVOICE)
        }
      >
        <th className={midas.textLeft} style={{ width: '160px' }}>
          {getText('transactions.headers.vat')}
        </th>
      </Conditional>
      <Conditional when={extraColumn !== null}>
        {() => <th className={midas.textLeft}>{extraColumn.title}</th>}
      </Conditional>
      <Conditional when={extraColumn === null}>
        <th className={midas.textLeft}>&nbsp;</th>
      </Conditional>
    </tr>
  )

  const isAccountCredit = () => {
    return (
      payment.paymentMethod.type === PaymentMethods.RESURS_NEW_CARD ||
      payment.paymentMethod.type === PaymentMethods.RESURS_CARD ||
      payment.paymentMethod.type === PaymentMethods.RESURS_PART_PAYMENT ||
      payment.paymentMethod.type === PaymentMethods.RESURS_REVOLVING_CREDIT ||
      payment.paymentMethod.type === PaymentMethods.RESURS_NEW_REVOLVING_CREDIT
    )
  }

  const entryRow = extraColumn => {
    return (
      <tr className={styles.entryRow} key={index}>
        <td>{`${moment(entry.created).format('L LT')}`}</td>
        <td>{entry.creator}</td>
        <td>
          <NumberFormat
            value={entry.cart.totalIncVat}
            displayType="text"
            thousandSeparator=" "
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            renderText={val => getText('default.currency', val)}
          />
        </td>
        <Conditional
          when={
            entry.channelType === ChannelType.ECOMMERCE ||
            entry.channelType === ChannelType.CHECKOUT_POS ||
            entry.channelType === ChannelType.MERCHANT_API ||
            (entry.channelType === ChannelType.MERCHANT_PORTAL &&
              payment.paymentMethod.type === PaymentMethods.RESURS_INVOICE)
          }
        >
          <td>
            <NumberFormat
              value={entry.cart.totalVat}
              displayType="text"
              thousandSeparator=" "
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              renderText={val => getText('default.currency', val)}
            />
          </td>
        </Conditional>
        <Conditional
          when={extraColumn !== null && extraColumn.type === 'INVOICE'}
        >
          {() => (
            <td>
              <InvoiceInfo {...extraColumn} />
            </td>
          )}
        </Conditional>
        <Conditional
          when={extraColumn !== null && extraColumn.type === 'ACCOUNT_CREDIT'}
        >
          <Conditional when={!config.disableReceiptSummary}>
            <td style={{ textAlign: 'right' }}>
              <SendDebitConfirmation index={index} />
            </td>
          </Conditional>
        </Conditional>
      </tr>
    )
  }

  const checkInvoiceNumberExtraColumn = () => {
    if (entry.invoiceRef) {
      return {
        title: getText('transactions.headers.invoiceNumber'),
        value: entry.invoiceRef,
        entry,
        payment,
        type: 'INVOICE',
      }
    }

    if (entry.type === TransactionTypes.DEBIT && !!isAccountCredit()) {
      return {
        index,
        type: 'ACCOUNT_CREDIT',
      }
    }

    return null
  }

  return (
    <div>
      <h6
        style={{
          margin: '2rem 1rem',
          borderBottom: '0.1rem solid #dcddde',
          paddingBottom: '1rem',
        }}
        key="debit-label"
      >
        {translateEntryType(entry.type)}
      </h6>
      <Table disableHover key="debit-table">
        <thead>{headers(checkInvoiceNumberExtraColumn())}</thead>
        <tbody>{entryRow(checkInvoiceNumberExtraColumn())}</tbody>
      </Table>
    </div>
  )
}

PaymentLogEntry.propTypes = {
  entry: PropTypes.object,
  payment: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}

PaymentLogEntry.defaultProps = { entry: null }

export default PaymentLogEntry
